import { API_ENDPOINTS, apiService } from "../api";
import { isMockApiFlag } from "../apiMode";
import { mockListWorkspaceLinkedDataSources } from "./workspaceLinkedDataSourcesApi.mock";
import { mapWorkspaceLinkedDataSourceListResponse } from "./workspaceLinkedDataSourcesMappers";
import type {
  WorkspaceLinkedDataSourceListResponse,
  WorkspaceLinkedDataSourceListResponseApi,
} from "./workspaceDataSources.types";

const isMockEnabled = (): boolean =>
  isMockApiFlag(process.env.REACT_APP_WORKSPACE_LINKED_DS_API);

const isLocalDevRuntime = (): boolean =>
  process.env.NODE_ENV === "development";

const buildUrl = (workspaceId: string, q?: string): string => {
  const params = new URLSearchParams();
  if (q?.trim()) params.set("q", q.trim());
  const qs = params.toString();
  return `${API_ENDPOINTS.workspaces.linkedDataSources(workspaceId)}${qs ? `?${qs}` : ""}`;
};

export const listWorkspaceLinkedDataSources = async (
  workspaceId: string,
  q?: string,
): Promise<WorkspaceLinkedDataSourceListResponse> => {
  if (isMockEnabled()) {
    return mapWorkspaceLinkedDataSourceListResponse(
      await mockListWorkspaceLinkedDataSources(workspaceId, q),
    );
  }

  try {
    const api = await apiService.get<WorkspaceLinkedDataSourceListResponseApi>(
      buildUrl(workspaceId, q),
    );
    return mapWorkspaceLinkedDataSourceListResponse(api);
  } catch (error) {
    if (isLocalDevRuntime()) {
      return mapWorkspaceLinkedDataSourceListResponse(
        await mockListWorkspaceLinkedDataSources(workspaceId, q),
      );
    }
    throw error;
  }
};
